export default __webpack_public_path__ + "static/Group-135-9861acab8965821181364f09511e14f6.svg";